module.exports = __webpack_public_path__ + "files/9ab97fd30b814d3c70429ee258787450.png";